import DashboardMain from 'pages/Dashboard';

import PageLayout from '../components/PageLayout';

const DashboardPage = () => (
	<PageLayout>
		<div className="Page-main">
			<DashboardMain />
		</div>
	</PageLayout>
);

export default DashboardPage;
